module.exports = __webpack_public_path__ + "img/app-tasks.5c83eb55.png";